// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__28fS7","chevronRight":"Chevron_chevronRight__2BrM1","chevronLeft":"Chevron_chevronLeft__trvp0","open":"Chevron_open__815xC"};